import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Dashboard from "./components/Dashboard";
import Checkout from "./components/Checkout";
import OrderStatus from "./components/OrderStatus";
import OrderComplete from "./components/OrderComplete";
import PaymentReturn from "./components/PaymentReturn";
import ErrorBoundary from "./components/ErrorBoundary";
import { OrderProvider } from "./context/OrderContext";
import { ConfigProvider } from "./context/ConfigContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AdminLogin from "./components/admin/AdminLogin";
import VenueAdminLogin from "./components/admin/VenueAdminLogin";
import SuperAdminDashboard from "./components/admin/SuperAdminDashboard";
import VenueAdminDashboard from "./components/admin/VenueAdminDashboard";
import "./App.css";

function SuperAdminGuard({ children }) {
  const { auth, isSuperAdmin } = useAuth();
  if (!auth) return <Navigate to="/admin/login" replace />;
  if (!isSuperAdmin) return <Navigate to="/admin/login" replace />;
  return children;
}

function VenueAdminGuard({ children }) {
  const { auth, isVenueAdmin } = useAuth();
  if (!auth) return <Navigate to="/venue-admin/login" replace />;
  if (!isVenueAdmin) return <Navigate to="/venue-admin/login" replace />;
  return children;
}

function App() {
  return (
    <ErrorBoundary>
      <ConfigProvider>
        <OrderProvider>
          <AuthProvider>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <div className="App">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-status/:orderId" element={<OrderStatus />} />
                  <Route
                    path="/order-complete/:orderId"
                    element={<OrderComplete />}
                  />
                  <Route path="/payment/return" element={<PaymentReturn />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route
                    path="/admin"
                    element={
                      <SuperAdminGuard>
                        <SuperAdminDashboard />
                      </SuperAdminGuard>
                    }
                  />
                  <Route path="/venue-admin/login" element={<VenueAdminLogin />} />
                  <Route
                    path="/venue-admin"
                    element={
                      <VenueAdminGuard>
                        <VenueAdminDashboard />
                      </VenueAdminGuard>
                    }
                  />
                </Routes>
                <Toaster position="top-right" />
              </div>
            </Router>
          </AuthProvider>
        </OrderProvider>
      </ConfigProvider>
    </ErrorBoundary>
  );
}

export default App;
